import { render, staticRenderFns } from "./PromptsList.vue?vue&type=template&id=0d1c74e9&scoped=true"
import script from "./PromptsList.vue?vue&type=script&lang=ts"
export * from "./PromptsList.vue?vue&type=script&lang=ts"
import style0 from "./PromptsList.vue?vue&type=style&index=0&id=0d1c74e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c74e9",
  null
  
)

export default component.exports